import React from 'react';
import './Loading.css';

const Loading = ({ fullScreen = false, text = '読み込み中...' }) => {
  if (fullScreen) {
    return (
      <div className="loading loading--fullscreen">
        <div className="loading__content">
          <div className="loading__spinner">
            <div className="loading__spinner-ring"></div>
            <div className="loading__spinner-ring"></div>
          </div>
          {text && <p className="loading__text">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="loading">
      <div className="loading__content">
        <div className="loading__spinner">
          <div className="loading__spinner-ring"></div>
          <div className="loading__spinner-ring"></div>
        </div>
        {text && <p className="loading__text">{text}</p>}
      </div>
    </div>
  );
};

export default Loading;
